import { StatusBadge } from "@/components/common/StatusBadge";
import { Section, Stat, inr, qtyFmt } from "./costingUi";

export function RecipeCostSummary({ data }) {
  const { recipe: r, totals: t, yield: y, costBridge: b, perUnit: u } = data;
  const noCost = y.confirmed ? "No priced lines" : "Yield not confirmed";
  const yieldText = y.confirmed ? `${qtyFmt(y.qty)} ${y.unit}` : null;
  return (
    <Section title="Recipe Summary" testId="recipe-summary"
      right={<span className="flex items-center gap-2 text-xs text-stone-500">{r.recipeNumber} · V{r.version} <StatusBadge value={r.status} /></span>}>
      <div className="mb-4 font-mono text-sm font-semibold text-stone-900" data-testid="recipe-summary-product">
        {r.productId} · {r.productName}
      </div>
      <div className="grid grid-cols-2 gap-x-6 gap-y-4 md:grid-cols-4">
        <Stat testId="summary-input-weight" label="Ingredient input weight (theoretical)"
          value={t.inputWeightKg != null ? `${qtyFmt(t.inputWeightKg)} kg` : "—"}
          sub={t.inputWeightKg != null && !t.weightIsTotalInput ? "weight lines only" : null} />
        <Stat testId="summary-input-volume" label="Ingredient input volume" value={t.inputVolumeL != null ? `${qtyFmt(t.inputVolumeL)} L` : "—"}
          sub={t.inputVolumeL != null ? "kept separate — no density conversion" : null} />
        <Stat testId="summary-batch-yield" label="Approved batch yield (finished)" value={yieldText} missing="Yield not confirmed"
          sub={y.theoreticalYield ? `Theoretical yield: ${qtyFmt(y.theoreticalYield)}` : "Saleable yield after process loss: not recorded"} />
        <Stat testId="summary-yield-unit" label="Yield unit" value={y.unit} missing="Yield not confirmed" />
        <Stat testId="summary-ingredient-cost" label="Ingredient cost / batch" value={inr(b.ingredientCost)}
          sub={!t.complete ? `Incomplete — ${t.unresolvedCount} unresolved line(s)` : null} />
        <Stat testId="summary-packaging-cost" label="Packaging cost / batch" value={inr(b.packagingCost)}
          sub={b.packagingSource === "NONE_RECORDED" ? "No packaging cost recorded" : null} />
        <Stat testId="summary-batch-cost" label="Total batch cost" value={inr(b.batchCost)} strong />
        <Stat testId="summary-cost-per-kg" label="Cost / kg finished product" value={inr(u.costPerKgFinished)}
          missing={y.confirmed ? "Yield not in weight" : "Yield not confirmed"} />
        <Stat testId="summary-cost-per-unit" label={`Cost / finished ${y.unit || "unit"}`} value={inr(u.currentUnitCost, 4)}
          missing={noCost} />
        <Stat testId="summary-current-cost" label="Current Cost (live master prices)" value={inr(u.currentUnitCost, 4)}
          missing={noCost} strong />
        <Stat testId="summary-decided-cost" label="Decided Cost (locked)" value={inr(u.decidedCost, 4)} missing="Not set" strong />
        <Stat testId="summary-input-cost-per-kg" label="Ingredient cost / kg input" value={inr(u.ingredientCostPerKgInput)}
          missing={t.weightIsTotalInput ? "No priced lines" : "Mixed units"} sub="raw input — not finished product" />
      </div>
    </Section>
  );
}
